import React from 'react';

import { useTranslation } from 'react-i18next';

import { Timeline } from '@weezevent/nacre';
import Style from './refundDetails.module.css';

function RefundContent({ refund, locale, timezone, currency, refundContent = 'div', type = 'create' }) {
    const formatter = new Intl.NumberFormat(locale, {
        currency,
        style: 'currency'
    });

    const Content = refundContent;

    return (
        <div className={Style.flex}>
            <div>
                <Content refund={refund} currencyFormatter={formatter} type={type} />
            </div>
        </div>
    );
}

export default function RefundDetails({ locale, currency, timezone, refundRequests, refundContent, refunds = [] }) {
    const { t } = useTranslation();
    const _refunds = React.useMemo(() => {
        let formatedRefunds = [];
        refunds.forEach(r => {
            formatedRefunds.push({
                id: parseInt(r.id_refund),
                requested_at: r.created_at,
                refund_type: 'refund',
                amount: r.amount,
                removed: null
            });
        });
        refundRequests.forEach(r => {
            r['refund_type'] = 'refundRequest';
        });

        const refundsArray = formatedRefunds.concat(refundRequests);
        return refundsArray;
    }, [refunds, refundRequests]);

    const timeline_data = React.useMemo(() => {
        let timeline = [];
        _refunds.forEach(refund => {
            timeline.push({
                title: t(`ticket.manager.attendee.${refund.refund_type}-title`),
                content: <RefundContent refund={refund} locale={locale} timezone={timezone} currency={currency} refundContent={refundContent} type={'create'} />,
                date: refund.requested_at
            });

            if (refund.removed && refund.removed != null) {
                timeline.push({
                    title: t('ticket.manager.attendee.refund_detail_deleted_title'),
                    content: <RefundContent refund={refund} locale={locale} timezone={timezone} currency={currency} refundContent={refundContent} type={'remove'} />,
                    date: refund.removed
                });
            }
        });
        return timeline;
    }, [_refunds, locale, currency, refundContent]);

    return <Timeline data={timeline_data} timezone={timezone} locale={locale} />;
}
